<div class="modal-container">
    <div class="modal-container__title text-center mb-3">
        {{ title | translate }}
    </div>

    <ul *ngIf="data.items?.length" class="confirm-items-list mb-3">
        <li *ngFor="let item of data.items">{{ item }}</li>
    </ul>

    <div class="action-buttons">
        <app-cancel-button [disabled]="false" class="me-0 me-sm-2 mb-2 mb-sm-0" (cancel)="cancel()"></app-cancel-button>
        <app-save-button [disabled]="false" (save)="save()" [text]="'Common.Confirm'"></app-save-button>
    </div>
</div>